
import SVGPlus from '@/UI/Components/SVG/SVGPlus.vue';
import NavbarGreenButton from '@/UI/Components/ComponentsNavbar/NavbarGreenButton.vue';
import { useStoreData } from '@/Store/storeData';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { order , saveXml } from '@/utils/postmessages';
import { $ } from '@/Engine/state';

import { loadResultPDF } from '@/pdf/createPDF';

export default {
  name: 'SidebarResultFooter',
  inject: [ 'currencySymbol', 'externalUser' ],
  components: { NavbarGreenButton, SVGPlus },
  setup() {
    const storeData = useStoreData();
    const configurationStore = useConfigurationStore();
    
    return {
      storeData,
      configurationStore,
    };
  },
  props: [
    'items',
  ],
  methods: {
    updateConfig() {
      this.configurationStore.addKit($.wardrobe.raw);
      $.render();
    },
    isDealer() {
      const { role } = v3d.AppUtils.getPageParams();

      return role === 'dealer';
    },
    order() {
      order();
    },
    saveXml() {
      saveXml();
    },
    createPDF(){
      loadResultPDF(this.items, this.currencySymbol, this.externalUser);
    },
  },
};
